import { motion } from 'framer-motion';

import UIConfig from '@/UIConfig.ts';
import CloseShape from '@/components/common/svg/shapes/CloseShape.tsx';

const CloseButton = ({ handleClose }: { handleClose: () => void }) => {
  return (
    <motion.div
      whileTap={{ scale: 0.8 }}
      onClick={(e) => e.stopPropagation()}
      onTap={(event) => {
        event.stopPropagation();
        handleClose();
      }}
      style={containerStyle}
    >
      <CloseShape
        fillColor={UIConfig.Colors.BackgroundLight}
        width={35}
        height={35}
        strokeWidth={1}
      />
    </motion.div>
  );
};

const containerStyle = {
  width: '36px',
  height: '36px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer'
};

export default CloseButton;
